import DownloadConfirmationModal from './downloadConfirmationModal.view';

export default DownloadConfirmationModal;
